<template>
	<Skeleton :paragraph="{ rows: 6 }" :title="false" :loading="loading">
		<Form :model="formState" :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }" :colon="false">
			<VerticalLayout>
				<div class="flex-wrapper align-baseline">
					<WarningTwoTone :two-tone-color="PINK" class="pd-sm-x" />
					<i18n-t keypath="settings.vrsSettingsForm.ntpHostsHint" tag="span" scope="global">
						<template #br>
							<br>
						</template>
						<template #ntp>
							<TypographyText code>ntp</TypographyText>
						</template>
						<template #http>
							<TypographyText code>http</TypographyText>
						</template>
						<template #https>
							<TypographyText code>https</TypographyText>
						</template>
					</i18n-t>
				</div>
				<FormItem v-bind="validateInfos.ntpHosts" :label="$t('settings.vrsSettingsForm.ntpHosts')">
					<Textarea v-model:value="formState.ntpHosts" :rows="6" :placeholder="$t('settings.vrsSettingsForm.ntpHostsPlaceholder')" />
				</FormItem>
			</VerticalLayout>
			<FormButtonsItem>
				<Button type="primary" @click.prevent="onSubmit" :loading="isSubmitting">
					{{ $t('settings.vrsSettingsForm.buttonLabel') }}
				</Button>
				<TaskRunButton taskLabel="run_script_timesync" />
			</FormButtonsItem>
		</Form>
	</Skeleton>
</template>

<script>
import { reactive, nextTick, toRaw, watch } from 'vue';
import { Button, Skeleton, Form, FormItem, Textarea, TypographyText } from 'ant-design-vue';
import { WarningTwoTone } from '@ant-design/icons-vue';

import Api from '@/api/Api';
import Consts from '@/api/Consts';
import Utils from '@/api/Utils';
import Validators from '@/api/Validators';

import TaskRunButton from '@/components/common/TaskRunButton';
import VerticalLayout from '@/components/common/VerticalLayout';
import FormButtonsItem from '@/components/common/FormButtonsItem.vue';

import { useVRSSettingsPost } from './useVRSSettingsPost.js'

import { useProvideInjectFormChangedStatuses } from '@/utils/useProvideInject';

export default {
	components: {
		Button, Skeleton, Form, FormItem, WarningTwoTone, Textarea, TypographyText,
		FormButtonsItem, TaskRunButton, VerticalLayout,
	},
	props: ['loading', 'settings'],
	setup(props) {
		const formState = reactive({
			ntpHosts: '',
		});
		const { validate, validateInfos } = Validators.useVRSSettingsOtherSettingsFormRules(formState);
		const { injectValue } = useProvideInjectFormChangedStatuses;
		const formChangedStatuses = injectValue();
		const { enableWatch, pauseWatch, resetChangedState } = Validators.useWatchFormChanges(formState, formChangedStatuses, 'OtherSettingsForm');
		const { isSubmitting, onSubmit } = useVRSSettingsPost(Api.vrsSettingsPost, formState, validate, toRaw, resetChangedState);
		watch(
			() => props.settings,
			value => {
				pauseWatch();
				Utils.updateObject(formState, value);
				nextTick(enableWatch);
			},
		);
		return {
			isSubmitting,
			formState,
			validateInfos,
			onSubmit,
			PINK: Consts.COLORS.pink,
		};
	},
}
</script>
